<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/plc" />
          <div class="ProductImages">
            <p>PLC可编程逻辑控制器、伺服驱动器、伺服电机等</p>
            <img :src="baseApi+ 'upload/product/4003.png'">
            <img :src="baseApi+ 'upload/product/4001.png'">
            <img :src="baseApi+ 'upload/product/4002.png'">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/view/componets/Banner'
import Tab from '@/views/view/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ProductImages {
  padding: 30px;
  img {
    width: 100%;
    margin: 20px 0;
  }
  p{
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view/plc.vue